import { Box, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { COMMON_STYLE } from '../../../../Utility/Constants'

const optometryNotesState = {
  patientId: '',
  appointmentId: '',
  clinicId: '',
  doctorId: '',
  optometryNotes: '',
  dupOptometryNotes: '',
}

const UmaOptometryNotes = React.forwardRef((props, ref) => {
  const [optNotes, setOptNotes] = useState(optometryNotesState)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: message,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: message,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performOptometryNotesAction: () => {
      if (JSON.stringify(optNotes.optometryNotes) !== optNotes.dupOptometryNotes) {
        postOptometryData()
      }
    }
  }))

  const apicalls = async () => {
    await getOptometryNotesData()
  }

  const getOptometryNotesData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OPTOMETRY_NOTES + '?appointment_id=' + props?.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let optData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setOptNotes((prev) => ({
          ...prev,
          optometryNotes: Object.keys(optData)?.length > 0 ? optData?.opto_comments : '',
          dupOptometryNotes: Object.keys(optData)?.length > 0 ? JSON.stringify(optData?.opto_comments) : JSON.stringify(''),
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postOptometryData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        opto_comments: optNotes.optometryNotes
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_OPTOMETRY_NOTES)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getOptometryNotesData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Box component={'div'}>
          <Box component={'div'} className='doc_notes_header_card'>
            <Typography className='doc_notes_header_card_font'>Optometry Notes</Typography>
          </Box>
          <Box component={'div'} m={'0.5rem'}>
            <TextField
              size='small'
              multiline
              fullWidth
              // rows={3}
              maxRows={3}
              disabled={props?.props?.patient_transfered || props?.props?.isLocked || (props?.props?.isOPT ? true : false)}
              value={optNotes.optometryNotes}
              onChange={(e) => {
                let value = e.target.value
                if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                  setOptNotes({ ...optNotes, optometryNotes: value })
                }
              }}
              placeholder='Optometry Comments'
              InputProps={{ emed_tid: 'opt_nts' }}
            />
          </Box>
        </Box>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaOptometryNotes